import type { ReactNode } from "react";

interface WorkspacePanelProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}

/**
 * A titled content panel: a header band with an optional title / subtitle,
 * above a padded body. Mirrors the dashboard panel used across the Mako
 * workspace mockup.
 */
export default function WorkspacePanel({
  title,
  subtitle,
  children,
  className = "",
}: WorkspacePanelProps) {
  return (
    <section
      className={`rounded-xl border border-grey-100 bg-white shadow-sm ${className}`}
    >
      {(title || subtitle) && (
        <div className="border-b border-grey-100 px-5 py-4">
          {title && (
            <h2 className="text-balance text-lg font-semibold text-blue-200">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="mt-1 text-pretty text-sm text-grey-200">{subtitle}</p>
          )}
        </div>
      )}

      <div className="px-5 py-4">{children}</div>
    </section>
  );
}
